var exports = {
  "X$": "x31de4314--a891c1--pagination",
  "kI": "x31de4314--a891c1--pages-list",
  "MY": "x31de4314--a891c1--page",
};

module.exports = exports;
